import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Bold,
  Italic,
  Code,
  Link,
  List,
  ListOrdered,
  Quote,
  Heading1,
  Heading2,
  Image,
  Smile
} from 'lucide-react';

const MarkdownToolbar = ({ onInsert, onEmojiClick }) => {
  const tools = [
    { icon: Bold, syntax: '**text**', label: 'Bold' },
    { icon: Italic, syntax: '*text*', label: 'Italic' },
    { icon: Code, syntax: '`code`', label: 'Inline Code' },
    { icon: Link, syntax: '[text](url)', label: 'Link' },
    { icon: Image, syntax: '![alt](image-url)', label: 'Image' },
    { icon: Heading1, syntax: '# ', label: 'H1' },
    { icon: Heading2, syntax: '## ', label: 'H2' },
    { icon: List, syntax: '- ', label: 'List' },
    { icon: ListOrdered, syntax: '1. ', label: 'Ordered List' },
    { icon: Quote, syntax: '> ', label: 'Quote' },
  ];

  const insertCodeBlock = () => {
    onInsert('```\n// your code here\n```');
  };

  return (
    <div className="flex flex-wrap items-center gap-1 p-2 border-b bg-gray-50" data-testid="markdown-toolbar">
      {tools.map((tool, index) => (
        <Button
          key={index}
          variant="ghost"
          size="sm"
          onClick={() => onInsert(tool.syntax)}
          title={tool.label}
          className="h-8 w-8 p-0"
          data-testid={`toolbar-${tool.label.toLowerCase().replace(' ', '-')}`}
        >
          <tool.icon className="w-4 h-4" />
        </Button>
      ))}
      <div className="w-px h-6 bg-gray-300 mx-1" />
      <Button
        variant="ghost"
        size="sm"
        onClick={insertCodeBlock}
        title="Code Block"
        className="h-8 px-2 text-xs font-mono"
        data-testid="toolbar-code-block"
      >
        {'{}'}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={onEmojiClick}
        title="Emoji"
        className="h-8 w-8 p-0"
        data-testid="toolbar-emoji"
      >
        <Smile className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default MarkdownToolbar;
